module.exports = __webpack_public_path__ + "img/user.c09fa42f.svg";